import css from 'styled-jsx/css';
import { colors } from '../../config/styles';

const FomoStyles = css`
  .fomo-container {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #bc001c;
    font-size: 14px;
    font-style: normal;
    line-height: 15px;
  }

  .clock-placeholder {
    width: 16px;
    height: 16px;
    background-color: ${colors.gray.shade32};
    border-radius: 50%;
    animation: pulse 1.5s infinite ease-in-out;
  }

  @keyframes pulse {
    0% {
      opacity: 0.6;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.6;
    }
  }

  .fomo-text {
    color: #bc001c;
    font-size: 14px;
    font-style: normal;
  }
`;

export { FomoStyles };
